import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Input, Tag } from 'antd';
import cookies from 'js-cookie';
import moment from 'moment';

import MainMenu from 'components/mainMenu';

import requestAPI from 'helpers/requestAPI';
import { toastError, toastSuccess, toastWarning } from 'utils/toastr';

import './index.scss';
import download from 'downloadjs/download';


const IndexChecker = () => {
    const interval = useRef();
    let checkerActive = cookies.get('indexChecker__process');
    const [ textareaValue, setTextareaValue ] = useState('');
    const [ timer, setTimer ] = useState(30);
    const [ checkerData, setCheckerData ] = useState([]);
    const [ tableLoading, setTableLoading ] = useState(false);
    const [ pagination, setPagination ] = useState({});

    const { TextArea } = Input;

    useEffect(() => {
        if(checkerActive) {
            getOrDownloadCheckerData();
        } 
    // eslint-disable-next-line
    }, []);
    

    useEffect(() => {
        if(checkerActive && JSON.parse(checkerActive).inProgress) {
            interval.current = setInterval(() => {
                setTimer((previousTimer) => {
                    if (previousTimer === 0) {
                        getOrDownloadCheckerData();
                        return 30;
                    }
                    
                    return previousTimer - 1;
                });
            }, 1000)
        } else {
            clearInterval(interval.current);
            setTimer(30);
        }

        return () => clearInterval(interval.current);
        // eslint-disable-next-line
    }, [checkerActive]);

    const getOrDownloadCheckerData = (csv = false, uid = '', all = {}) => {
        if (!csv) setTableLoading(true);
        const queryParams = Object.keys(all).length ? {
            ...all
        } : {
            uid: uid ? uid : JSON.parse(cookies.get('indexChecker__process')).uid,
            csv
        };

        const params = {
            routeParams: {
                route: 'google_index'
            },
            additionalQueryStringParams: {
                ...queryParams
            }
        }
        
        requestAPI(params).then(resp => {
            if(csv) {
                let blob = new Blob([resp.data], {type:'text/csv'});
                download(blob, 'name.csv', 'text/csv')
                return;
            }
            if(Object.keys(all).length) {
                setPagination({
                    ...pagination,
                    current: resp.data.current_page,
                    pageSize: 24,
                    total: resp.data.page_count * 24
                })
                setCheckerData(() => {
                    return resp.data.data.map((elem, index) => ({
                        key: index,
                        link: elem.uid,
                        date: moment(elem.time_start).format('YYYY-MM-DD HH:mm'),
                        done: resp.data.data.length - 1 === index 
                            && resp.data.current_page === resp.data.page_count ? !resp.data.still_works : true
                    }))
                });
                setTableLoading(false);
                return;
            }
            if (!resp.data.still_works) {
                cookies.set(
                    'indexChecker__process', 
                    JSON.stringify({uid: JSON.parse(checkerActive).uid, inProgress: resp.data.still_works}),
                    {expires: 100}
                );
            }

            setCheckerData([...checkerData, {
                key: checkerData.length, 
                link: resp.data.data[0].uid, 
                date: moment(resp.data.data[0].time_start).format('YYYY-MM-DD HH:mm'),
                done: !resp.data.still_works
            }])
            
            setTableLoading(false);
        }).catch(err => toastError(err))
    }

    const onTextareaChange = (e) => {
        setTextareaValue(e.target.value)
    }

    const onCheckClick = () => {
        if (!textareaValue) {
            toastWarning('Please enter query');
            return;
        }

        const params = {
            routeParams: {
                route: 'google_index'
            },
            method: 'POST',
            data: {
                data: textareaValue
            }
        }

        requestAPI(params).then((result) => {
            cookies.set('indexChecker__process', JSON.stringify({
                uid: result.data.data.uid,
                inProgress: true
            }), {expires: 100});
            setCheckerData([]);
            setTextareaValue('');
            toastSuccess('Checker started work.');
        }).catch(err => {
            toastError(err.response.data.error)
        })
    }

    const onDownloadClick = (uid) => {
        getOrDownloadCheckerData(true, uid);
    }

    const showHistory = () => {
        getOrDownloadCheckerData(null, null, {
            all: true,
            page: 1 
        });
    };

    const onChangePagination = (pagination) => {
        setPagination({...pagination});
        getOrDownloadCheckerData(null, null, {
            all: true,
            page: pagination.current
        })
    }

    const columns = [
		{
			title: 'Date',
			dataIndex: 'date',
			key: 'date',
		},
		{
			title: 'Link',
			dataIndex: 'link',
            key: 'link',
            render: (value) => <span style={{cursor: 'pointer', color: '#1890ff'}} onClick={() => onDownloadClick(value)}>Download</span>
        },
        {
            title: 'Done',
            dataIndex: 'done',
            key: 'done',
            render: (value) => {
                return value ? <Tag color="green">{`${value}`}</Tag> : <Tag color="red">{`${value}`}</Tag>;
            }
        }
    ];
    return (
        <div>
            <MainMenu />
            <div className="wrapper">
                <div className="functional-area__left">
                    <TextArea 
                        rows={8} 
                        placeholder="Enter sites" 
                        className="functional-area__left__textarea" 
                        value={textareaValue} 
                        onChange={onTextareaChange} 
                    />
                    <Button type="primary" onClick={onCheckClick}>Check</Button>
                </div>
                <div className="functional-area__right">
                    <span>Refresh after: {timer}</span>
                    <Table 
                        scroll={{y: '264px', x: '100%'}}
                        columns={columns}
                        dataSource={checkerData}
                        pagination={Object.keys(pagination).length ? pagination : true}
                        size={'small'}
                        loading={tableLoading}
                        onChange={Object.keys(pagination).length ? onChangePagination : null}
                    />
                    <Button className="functional-area__right__history-btn" type="primary" onClick={showHistory}>Show History</Button>
                </div>
            </div>
        </div>
    )
};

export default IndexChecker;